/* ====================
   TM Product Recommendations Carousel
   ==================== */

document.addEventListener("DOMContentLoaded", function () {
  function initTMProductRecommendationsCarousel() {
    if (typeof Swiper === "undefined") {
      setTimeout(initTMProductRecommendationsCarousel, 300);
      return;
    }

    const carouselElements = document.querySelectorAll(
      ".tm-product-recommendations-carousel"
    );

    carouselElements.forEach(function (el) {
      const container = el.closest(".tm-product-recommendations");
      if (!container) return;

      // Destroy existing swiper instance if any
      if (el.swiper) {
        el.swiper.destroy(true, true);
      }

      const productsInView = parseInt(el.dataset.productsInView) || 3;
      const prevBtn = container.querySelector(
        ".tm-product-recommendations__arrow--prev"
      );
      const nextBtn = container.querySelector(
        ".tm-product-recommendations__arrow--next"
      );
      const pagination = container.querySelector(
        ".tm-product-recommendations__pagination"
      );

      // Initialize Swiper
      new Swiper(el, {
        slidesPerView: productsInView,
        spaceBetween: 8,
        watchOverflow: true,
        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn,
          disabledClass: "swiper-button-disabled",
        },
        pagination: {
          el: pagination,
          clickable: true,
          type: "bullets",
          renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
          },
        },
        scrollbar: false,
        on: {
          init: function () {
            this.pagination.render();
            this.pagination.update();
            this.navigation.update();
          },
          slideChange: function () {
            this.navigation.update();
            this.pagination.update();
          },
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 4,
          },
          480: {
            slidesPerView: 1.5,
            spaceBetween: 4,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 4,
          },
          1024: {
            slidesPerView: productsInView,
            spaceBetween: 4,
          },
        },
      });
    });
  }

  initTMProductRecommendationsCarousel();

  // Re-initialize on Shopify section updates
  if (window.Shopify) {
    document.addEventListener("shopify:section:load", function () {
      setTimeout(initTMProductRecommendationsCarousel, 100);
    });
  }

  // Wishlist functionality
  document.addEventListener("click", function (e) {
    if (e.target.closest(".tm-product-recommendations__wishlist")) {
      const button = e.target.closest(".tm-product-recommendations__wishlist");
      const productId = button.dataset.productId;

      button.classList.toggle("active");

      // You can add Swym or custom wishlist logic here
      console.log("Wishlist toggled for product:", productId);
      e.preventDefault();
    }
  });
});
